import { useRouter } from 'next/router';
import { useCallback, useMemo } from 'react';
const specialParams = ['id', 'startDate', 'endDate'];
const setQueryParams = (router, params) => {
  const newParams = {
    ...params
  };
  specialParams.forEach(k => {
    delete newParams[k];
  });
  const newQuery = {
    ...router.query
  };
  Object.keys(newParams).forEach(k => {
    if (newParams[k]) {
      newQuery[k] = newParams[k];
    } else {
      delete newQuery[k];
    }
  });
  router.push({
    pathname: router.pathname,
    query: newQuery
  });
};
const useQueryStringArgs = () => {
  const router = useRouter();
  const currentParams = useMemo(() => {
    const params = {};
    Object.keys(router.query).filter(k => !specialParams.includes(k)).forEach(k => {
      Object.defineProperty(params, k, {
        value: router.query[k]
      });
    });
    return params;
  }, [router]);
  const setParams = useCallback(val => setQueryParams(router, val), [router]);
  return [currentParams, setParams];
};
export default useQueryStringArgs;